import { createAsyncType } from '@/store/utils/mutation-types'

export default {
  GET_USERS: createAsyncType('GET_USERS')
}
